<template>
  <span class="subtitle-1 font-weight-medium">{{ resultCountToDisplay }}</span>
</template>

<script>
export default {
  name: "SearchDisplayNumberResult",
  props: {
    resultCount: {
      type: Number,
      required: true
    },
    searchType: {
      type: String,
      required: true
    }
  },
  computed: {
    resultCountToDisplay() {
      if (this.searchType === "destinations") {
        return `${this.resultCount} ${
          this.resultCount > 1
            ? this.$t("app.plural_GEM")
            : this.$t("app.singular_GEM")
        }`;
      } else if (this.searchType === "posts") {
        return `${this.resultCount} ${
          this.resultCount > 1
            ? this.$t("app.plural_EXPERIENCE")
            : this.$t("app.singular_EXPERIENCE")
        }`;
      }
      return null;
    }
  }
};
</script>
